import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let account = {
	namespaced: true,
	state: {
		userBeingViewed: null,
		currentUser: null,
	},
	mutations: {
		setUserBeingViewed(state, newUserBeingViewed) {
			state.userBeingViewed = newUserBeingViewed;
		},
		setCurrentUser(state, newCurrentUser) {
			state.currentUser = newCurrentUser;
		},
	},
	actions: {
		updateUserBeingViewed(context, newUserBeingViewed) {
			context.commit("setUserBeingViewed", newUserBeingViewed);
		},
		updateCurrentUser(context, currentUser) {
			context.commit("setCurrentUser", currentUser);
		},
		resetStore(context) {
			context.commit("setCurrentUser", null);
			context.commit("setUserBeingViewed", null);
		},
	},
	getters: {
		userBeingViewed: (state) => {
			return state.userBeingViewed;
		},
		currentUser: (state) => {
			return state.currentUser;
		},
	},
};

// eslint-disable-next-line no-unused-vars
const store = new Vuex.Store({
	modules: {
		account: account,
		groups: {
			namespaced: true,
			state: {
				cacheExpiresOn: new Date(),
			},
			mutations: {},
			actions: {},
			getters: {
				cacheExpiresOn: (state) => {
					return state.cacheExpiresOn;
				},
			},
		},
	},
});

export default store;
